const transformTranslationsMetaobjectData = (
  fields: { key: string; value: string }[],
): Record<string, string> => {
  return fields.reduce((acc, val) => {
    acc[val.key] = val.value;
    return acc;
  }, {} as Record<string, string>);
};

export default transformTranslationsMetaobjectData;
